import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import client from "@/lib/api";
import Layout from "@/components/Layout";
import { FileText } from "lucide-react";
import { RT, STATUS_COLORS, Th, Td } from "@/components/rmsreport/ui";

const FILTERS = ["ALL", "DRAFT", "PENDING REVIEW", "RETURNED", "APPROVED", "SUPPLEMENT REQUIRED"];

export default function RmsReportsList() {
  const nav = useNavigate();
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState("ALL");
  useEffect(() => {
    client.get("/rms-reports", { params: filter === "ALL" ? {} : { status: filter } })
      .then((r) => setRows(r.data)).catch(() => {});
  }, [filter]);
  return (
    <Layout>
      <div className="p-4" data-testid="rms-reports-list">
        <div className="flex items-center gap-2 mb-3">
          <FileText size={16} className="text-[#22D3EE]" />
          <span className="font-head font-bold text-sm text-white tracking-wider">RMS INCIDENT REPORTS</span>
          <div className="ml-auto flex gap-1">
            {FILTERS.map((f) => (
              <button key={f} data-testid={`rr-filter-${f.replace(/ /g, "-")}`} onClick={() => setFilter(f)}
                className={`px-2 py-1 font-mono text-[9px] uppercase rounded-sm border ${filter === f ? "bg-[#22D3EE] text-black border-[#22D3EE]" : "text-[#9CA3AF] border-[#2C2D35]"}`}>{f}</button>
            ))}
          </div>
        </div>
        <div className="border rounded-sm overflow-hidden bg-white" style={{ borderColor: RT.border }}>
          <table className="w-full">
            <thead style={{ background: "#eef2f6" }}>
              <tr><Th>RMS CASE</Th><Th>CASE/CFS</Th><Th>INCIDENT TYPE</Th><Th>LOCATION</Th><Th>REPORTING OFFICER</Th><Th>STATUS</Th><Th>CREATED</Th></tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} data-testid={`rr-list-${r.case_number}`} onClick={() => nav(`/rms-report/${r.id}`)}
                  className="cursor-pointer hover:bg-[#eef4f9]">
                  <Td><span className="font-bold" style={{ color: RT.head }}>{r.case_number}</span></Td>
                  <Td>{r.cad_number}</Td>
                  <Td>{r.incident?.incident_type || r.incident?.call_type || "—"}</Td>
                  <Td mono={false}>{r.incident?.location_name || r.incident?.address || "—"}</Td>
                  <Td>{r.reporting_officer?.name || r.created_by}</Td>
                  <Td><span className="px-1.5 py-0.5 text-[9px] font-bold text-white rounded-sm"
                    style={{ background: STATUS_COLORS[r.status] || "#334155" }}>{r.status}</span></Td>
                  <Td>{r.created_at?.slice(0, 16)}</Td>
                </tr>
              ))}
              {rows.length === 0 && <tr><Td mono={false}> No incident reports {filter !== "ALL" ? `with status ${filter}` : "yet"}.</Td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
}
